import sampleClassLogo from "assets/img/rectangle-logo-v2.png";
import {
  LOCAL_MOCK_SAMPLE_CLASS_ID,
  LOCAL_MOCK_SAMPLE_ONBOARDING_BOX_ID,
  LOCAL_MOCK_SAMPLE_RECORDINGS_BOX_ID,
} from "./localMockSampleClassConstants";
import {
  LEGACY_SAMPLE_CLASS_ID,
  createGettingStartedOnboardingBox,
  createGettingStartedRecordingsBox,
} from "./gettingStartedClass";

export {
  LOCAL_MOCK_SAMPLE_CLASS_ID,
  LOCAL_MOCK_SAMPLE_ONBOARDING_BOX_ID,
  LOCAL_MOCK_SAMPLE_RECORDINGS_BOX_ID,
};

const LOCAL_MOCK_SAMPLE_SOURCE_CLASS_ID = LEGACY_SAMPLE_CLASS_ID;

export function isLocalMockSampleClassEnabled({
  nodeEnv = process.env.NODE_ENV,
  user = null,
} = {}) {
  return nodeEnv === "development" && user?.settings?.role === "admin";
}

export const createLocalMockSampleOnboardingBox = () =>
  createGettingStartedOnboardingBox(LOCAL_MOCK_SAMPLE_ONBOARDING_BOX_ID);

export const createLocalMockSampleRecordingsBox = () =>
  createGettingStartedRecordingsBox(LOCAL_MOCK_SAMPLE_RECORDINGS_BOX_ID);

export function buildLocalMockSampleClass(options = {}) {
  if (!isLocalMockSampleClassEnabled(options)) {
    return null;
  }

  const contentBoxes = [
    createLocalMockSampleOnboardingBox(),
    createLocalMockSampleRecordingsBox(),
  ];

  return {
    classData: {
      classId: LOCAL_MOCK_SAMPLE_CLASS_ID,
      period: "",
      className: "Sample Class",
      startTime: null,
      endTime: null,
      showMarquee: true,
      showClock: true,
      active: true,
      contentBoxesOrder: contentBoxes.map((box) => box.contentBoxId),
      showClassInfoSchedule: false,
      showClassInfoLogo: true,
      classInfoLogoUrl: sampleClassLogo,
      classInfoLogoStoragePath: "",
      localMockSampleClass: true,
      localMockSourceClassId: LOCAL_MOCK_SAMPLE_SOURCE_CLASS_ID,
    },
    contentBoxes,
  };
}

export function maybeAppendLocalMockSampleClass(classes = [], options = {}) {
  if (!Array.isArray(classes)) {
    return classes;
  }

  if (classes.some((classItem) => classItem?.classId === LOCAL_MOCK_SAMPLE_CLASS_ID)) {
    return classes;
  }

  const mockClass = buildLocalMockSampleClass(options)?.classData;
  if (!mockClass) {
    return classes;
  }

  return [...classes, mockClass];
}

export function getLocalMockSampleClassContentBoxes(classId, options = {}) {
  if (classId !== LOCAL_MOCK_SAMPLE_CLASS_ID) {
    return null;
  }

  return buildLocalMockSampleClass(options)?.contentBoxes || null;
}

export function getOrderOfClassesWithLocalMockSampleClass(orderOfClasses = [], options = {}) {
  if (!Array.isArray(orderOfClasses)) {
    return orderOfClasses;
  }

  if (!isLocalMockSampleClassEnabled(options)) {
    return orderOfClasses;
  }

  if (orderOfClasses.includes(LOCAL_MOCK_SAMPLE_CLASS_ID)) {
    return orderOfClasses;
  }

  return [...orderOfClasses, LOCAL_MOCK_SAMPLE_CLASS_ID];
}
